export const environment = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  APP_NAME: process.env.REACT_APP_APP_NAME,
};

// prd
// export const environment = {
//   BASE_URL: "https://apptiva.in/backend/api/",
//   APP_NAME: "spent_app_v3",
// };

// export const environment = {
//   BASE_URL: "https://rootapi.rf.gd/backend/api/",
//   APP_NAME: "spent_app",
// };
